export const SPECIALTY_FLOW = {
  CONFIG_ID: 1021,

  BRANCHES: {
    ROOT: 'ROOT',
    URGENT: 'URGENT',
    NEW_DENTIST: 'NEW_DENTIST',
    SPECIALIST: 'SPECIALIST',
  },

  MARKETS: ['sacramento', 'seattle', 'houston', 'los angeles', 'new york city'],
};
